import { render, staticRenderFns } from "./LoanStaticsDetail.vue?vue&type=template&id=14d327d1&scoped=true&"
import script from "./LoanStaticsDetail.vue?vue&type=script&lang=js&"
export * from "./LoanStaticsDetail.vue?vue&type=script&lang=js&"
import style0 from "./LoanStaticsDetail.vue?vue&type=style&index=0&id=14d327d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d327d1",
  null
  
)

export default component.exports